
var envHelper = require('../envHelper.js');

/**
 * 中介者对象，管理Paint各部分之间的交互，降低耦合性
 */
var Mediator = {

  reactComp: null,
  Opreations: null,
  Events: null,
  LayerManager: null,
  Data: null,
  InputText: null,

  toolKey: null,
  initNum: 0,       //该变量临时写在这里，处理光标在canvas上的显示问题

  init: function(reactComp, opreations, events, layerManager, data, tool, inputText) {
    this.reactComp = reactComp;
    this.Opreations = opreations;
    this.Events = events;
    this.LayerManager = layerManager;
    this.Data = data;
    this.Tool = tool;
    this.InputText = inputText;
  },

  //此方法临时处理光标不正常问题，待优化
  resetEvents: function() {
    if(this.toolKey && this.initNum < 1) {
      this.initEvents(this.toolKey);
      this.initNum++;
    }
  },

  //传入选中工具
  initEvents: function(toolKey) {
    this.toolKey = toolKey;
    var setCanvasEvents = function() {
      var canvasEvents = Mediator.Tool[toolKey].canvasEvents;
      for (var key in canvasEvents) {
        if(canvasEvents[key]) {
          Mediator.getCanvas()[key] = Mediator.Events[canvasEvents[key]];
        } else {
          Mediator.getCanvas()[key] = null;
        }
      }
    };

    setCanvasEvents();
    this.Events.clearKeyEvents();

    //mac下快捷键设置
    if(envHelper.isMac()) {
      this.registKeyEvent(8, function() {
        Mediator.deleteLayer();
      });
      this.registKeyEvent(90, function() {
        Mediator.reactComp.rollBack();
      }, 'metaKey');
      this.registKeyEvent(89, function() {
        Mediator.reactComp.reRollBack();
      }, 'metaKey');
    } else {
      //加载delete按下删除选中图层事件
      this.registKeyEvent(46, function() {
        Mediator.deleteLayer();
      });
      this.registKeyEvent(90, function() {
        Mediator.reactComp.rollBack();
      }, 'ctrlKey');
      this.registKeyEvent(89, function() {
        Mediator.reactComp.reRollBack();
      }, 'ctrlKey');
    }

    this.Events.initFlags();
  },

  setLayerEvents: function() {
    var getLayerEvents = function(layer) {
      if(!layer.data.tool) {
        return;
      }
      var layerEventKeys = Mediator.Tool[layer.data.tool].layerEvents;
      var layerEvents = {};
      for(var key in layerEventKeys) {
        if (layer.data.author === Mediator.Data.getAuthor()) {
          layerEvents[key] = Mediator.Events[layerEventKeys[key]];
        } else {
          layerEvents[key] = null;
        }
      }
      return layerEvents;
    };
    var layers = $(Mediator.getCanvas()).getLayers();
    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];
      if(layer.groups[0] === 'points') {
        continue;
      }
      var layerEvents = getLayerEvents(layer);
      $(Mediator.getCanvas()).setLayer(layer, layerEvents);
    }
  },

  switchToEdit: function() {
    var layer = this.getCurrentLayer();
    this.initLayerEvents(layer);
    Mediator.checkCurrent();
  },

  registKeyEvent: function(code, func, combo) {
    Mediator.Events.registKeyEvent(code, func, combo);
  },

  initLayerEvents: function(layer) {
    var eventKeys = this.Tool[layer.data.tool].layerEvents;
    var obj = {};
    for(var key in eventKeys) {
      obj[key] = this.Events[eventKeys[key]];
    }
    $(this.reactComp.canvas).setLayer(layer, obj);
  },

  getCanvas: function() {
    return this.reactComp.canvas;
  },

  adapteText: function(text) {
    var layer = this.getCurrentLayer();
    var relativeLayers = this.getBindLayers(layer);
    this.InputText.adapteText(text, relativeLayers[0]);
  },
  doMoveLayer: function(dx, dy) {
    var target = this.getCurrentLayer();
    if(!target) {
      return null;
    }
    var key = this.Tool[target.data.tool].moveLayer;
    var result = this.Opreations[key](target, dx, dy);
    this.loadCheckPoint();
    return result;
  },

  //鼠标按下图层后调用，加载选择点
  loadCheckPoint: function() {
    var templete = this.Tool.templetePoint;
    templete.mousedown = this.Events['pointMouseDown'];
    templete.mousemove = this.Events['pointMouseMove'];
    templete.mouseover = this.Events['pointMouseOver'];
    templete.mouseout = this.Events['pointMouseOut'];
    templete.mouseup = this.Events['pointMouseUp'];

    var target = this.getCurrentLayer();
    //this.LayerManager.pushToTop(target);

    var key = this.Tool[target.data.tool].initCheckPoint;
    var objs =  this.Opreations[key](templete, target);
    this.LayerManager.drawPoint(objs);
  },

  doDragBorder: function(dx, dy, mx, my) {
    var target = this.getCurrentLayer();
    if(!target) {
      return null;
    }
    var point = this.Events.data.checkedPoint;
    var key = this.Tool[target.data.tool].dragBorder;
    var result = this.Opreations[key](target, point, dx, dy, mx, my);
    this.loadCheckPoint();
    return result;
  },

  getRef: function(key) {
    return this.reactComp.refs[key];
  },

  getProps: function(key) {
    return this.reactComp.props[key];
  },

  setState: function(state) {
    this.reactComp.setState(state);
  },

  save: function() {
    var add = this.reactComp.props.onAddReview;
    var update = this.reactComp.props.onUpdateReview;
    var remove = this.reactComp.props.onRemoveReview;
    this.Data.save(add, update, remove);
  },

  sendRequest: function() {
    var add = this.reactComp.props.onAddReview;
    var update = this.reactComp.props.onUpdateReview;
    var remove = this.reactComp.props.onRemoveReview;
    this.Data.sendRequest2(add, update, remove);
  },

  checkCurrent: function() {
    var current = this.getCurrentLayer();
    if(current) {
      if(this.InputText.isInput) {        //输入状态，不加载选择点
        return;
      }
      this.loadCheckPoint();
    }
  },

  reset: function() {
    if(this.getCurrentLayer()) {
      if(this.InputText.isInput) {
        this.InputText.saveTextData();
      }

      this.LayerManager.clearPoints();
      this.Events.data.currentCid = null;
    }
  },

  clearAll: function() {
     this.LayerManager.clearAll();
  },

  clearSelf: function() {
    this.reset();
    var ids =this.LayerManager.clearSelf();
    this.Data.deleteLayer(ids);
  },

  clearPoints: function() {
    this.Events.flags.onPoint = false;
    this.LayerManager.clearPoints();
  },

  isClearable: function() {
    return this.LayerManager.isClearable();
  },

  deleteLayer: function() {
    if(!this.InputText.isInput) {
      var layer = this.getCurrentLayer();
      this.reset();
      var ids = this.LayerManager.deleteLayer(layer);
      this.Data.deleteLayer(ids);
    }
  },

  setVisible: function(isVisible) {
    this.LayerManager.setVisible(isVisible);
  },

  addNewLayer: function(e, canvasContext, state) {
    var x = e.pageX - $(canvasContext).offset().left + Mediator.reactComp.scrollLeft;
    var y = e.pageY - $(canvasContext).offset().top + Mediator.reactComp.scrollTop;
    var tool = this.Tool[this.toolKey];
    if(tool) {
      var obj = tool.drawingData(x, y, state);
      if(obj) {
        return this.LayerManager.addLayer(obj);
      }
      return -1;
    }
  },

  replaceOldLayer: function(e, canvasContext, state) {

    if(this.getCurrentLayer()) {
      var currentIndex = this.getCurrentLayer().index;
      $(Mediator.getCanvas()).removeLayer(currentIndex);
    }
    return this.addNewLayer(e, canvasContext, state);
  },

  //获取与图层绑定的所有图层
  getBindLayers: function(layer) {
    return this.LayerManager.getBindLayers(layer);
  },

  //选中的文本背景添加文本
  appendTextLayer: function(value) {
    var backLayer = this.getCurrentLayer();
    var tool = this.Tool[backLayer.data.tool];
    if(tool && tool.appendText) {
      var obj = tool.appendText(backLayer, value);
      return this.LayerManager.addLayer(obj);
    }
  },

  restore: function() {
    this.Data.restore2();
    this.updateReact();
  },

  figureTextWidth: function(textValue, obj, backLayer) {
    return this.InputText.figureTextWidth(textValue, obj, backLayer);
  },

  getToolByLayer: function(layer) {
    if(layer) {
      if(this.Tool[layer.data.tool]) {
        return this.Tool[layer.data.tool];
      }
    }
    return null;
  },

  getStyle: function(tool, key) {
    return this.Tool.getStyle(tool, key);
  },

  flipPoints: function(checkPoint, axis) {
    this.Events.data.checkedPoint = this.LayerManager.flipPoints(checkPoint, axis);
  },

  updateReact: function() {
    this.reactComp.update();
  },

  getCid: function() {
    var id = this.LayerManager.getCid();
    return id;
  },

  getCurrentLayer: function() {
    var layerCid = this.Events.data.currentCid;
    var layer = this.LayerManager.getLayerByCid(layerCid);
    if(layer) {
      return this.LayerManager.getBindLayers(layer)[0];
    }
    return null;
  },

  getLayerByCid: function(layerCid) {
    return this.LayerManager.getLayerByCid(layerCid);
  },

  getCursorStyle: function(layer) {
    return this.LayerManager.getCursorStyle(layer);
  },

  getAuthor: function() {
    return this.Data.getAuthor();
  },

  setArrowSize: function(target) {
    this.Opreations.setArrowSize(target);
  },

  setCurrentCid: function(cid) {
    this.Events.data.currentCid = cid;
  },

  hiddenLayer: function(layer) {
    this.LayerManager.hiddenLayer(layer);
  },

  showLayer: function(layer) {
    this.LayerManager.showLayer(layer);
  },

  openTextArea: function() {
    if(this.getCurrentLayer() !== null) {
      this.InputText.openTextArea();
    }
  },

  isOnArrow: function(x, y) {
    return this.LayerManager.isOnArrow(x, y);
  }
};

module.exports = Mediator;


// WEBPACK FOOTER //
// ./src/helper/Review/Mediator.js